import { gql } from '@apollo/client';

const DELETE_LEARNING_OBJECT_MUTATION = gql`
    mutation deleteLearningObject( $objectID: UUID! ) {
        result: deleteLearningObject( objectID: $objectID ) {
            affectedRows
        }
    }
`;

export default DELETE_LEARNING_OBJECT_MUTATION;
